module.exports = __webpack_public_path__ + "static/media/Winner2.11df34f3.png";